export const AttachmentTypeEnum = Object.freeze({
    Image: 1,
    File: 2
});

export default AttachmentTypeEnum;